<template>
  <div
    v-if="isWithNewAtcButtonDesignEnabled"
    :aria-hidden="isMobile"
    class="hidden md:block"
  >
    <div class="flex justify-between">
      <ContainerProductTitles />
      <ContainerFavoritesToggle />
      <ContainerRatingInfo />
      <div class="mt-24 flex flex-col items-start gap-12">
        <ContainerPrice />
        <ContainerAddToCart
          class="w-full min-w-[164px] grow"
          data-id="product-page-buy-button-desktop"
          data-qa="product-page-buy-button-desktop"
        />
      </div>
    </div>
  </div>
  <div
    v-if="!isWithNewAtcButtonDesignEnabled"
    :aria-hidden="isMobile"
    class="hidden md:block"
  >
    <ContainerProductTitles />
    <ContainerRatingInfo />
    <div class="mt-24 flex items-center gap-12">
      <ContainerPrice />
      <ContainerAddToCart
        class="min-w-[164px] max-w-[256px] grow"
        data-id="product-page-buy-button-desktop"
        data-qa="product-page-buy-button-desktop"
      />
      <ContainerFavoritesToggle />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

import ContainerAddToCart from '~/scopes/product-core/components/containers/ContainerAddToCart/ContainerAddToCart.vue'
import ContainerPrice from '~/scopes/product-core/components/containers/ContainerPrice/ContainerPrice.vue'
import ContainerFavoritesToggle from '~/scopes/product-core/components/containers/ContainerProductSummary/components/ContainerFavoritesToggle/ContainerFavoritesToggle.vue'
import ContainerRatingInfo from '~/scopes/product-core/components/containers/ContainerProductSummary/components/ContainerRatingInfo/ContainerRatingInfo.vue'
import ContainerProductTitles from '~/scopes/product-core/components/containers/ContainerProductTitles/ContainerProductTitles.vue'

// @FIXME: potential hydration mismatch caused by client-only breakpoint detection
const breakpoint = useClientOnlyComputedBreakpoint()
const isMobile = computed(() => breakpoint.value < Breakpoint.MD)

const experiments = useExperiments()
const isWithNewAtcButtonDesignEnabled =
  experiments['experiment.ppNewATCButtonDesign'] === 'withNewATCButtonDesign'
</script>
